module.exports = __webpack_public_path__ + "static/easy-image-1-02250413b2d0a1349056c527770879c4.jpg";